import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { Form, Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';
import Waitable from '../../components/Waitable';
import { ReduxInput, ReduxMaskedInput } from '../../components/ReduxInput';
import { isValidEmail, isRequired, isValidPhoneNumber } from '../../components/ReduxInput/Validators';
import { generate } from 'generate-password';



class AddUserForm extends React.Component {
  render() {
    let { handleSubmit, toggle, signupState, dispatchResetSignup } = this.props;
    return <Form onSubmit={handleSubmit}>
      <Waitable entities={[signupState]} resetOnError={dispatchResetSignup}>
        <ModalBody>
          <FormGroup>
            <Label htmlFor="firstName">First Name</Label>
            <Field
            id="firstName"
              name="firstName"
              type="text"
              placeholder="John"
              component={ReduxInput}
              validate={[isRequired]}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="lastName">Last Name</Label>
            <Field
              validate={[isRequired]}
              id="lastName"
              name="lastName"
              type="text"
              placeholder="Doe"
              component={ReduxInput} />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="email">Email</Label>
            <Field
              validate={[isRequired, isValidEmail]}
              id="email"
              name="email"
              type="text"
              placeholder="example@example.com"
              component={ReduxInput} />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="phone">Phone</Label>
            <Field
              validate={[isRequired, isValidPhoneNumber]}
              name="phone"
              id="phone"
              type="text"
              placeholder="(832) 555-1234"
              mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              component={ReduxMaskedInput} />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="password">Password <small>(save password, it will not be visible again!)</small></Label>
            <Field
              id="password"
              name="password"
              type="text"
              disabled={true}
              component={ReduxInput} />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button id={"submitAddUser"} type="submit"
            color="primary"
          >Add</Button>{' '}
          <Button id={"submitCancel"} onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Waitable>
    </Form >;
  }
}

const ReduxAddUserForm = reduxForm({
  form: 'AddUserForm', // a unique identifier for this form
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true
})(AddUserForm);

export default class AddUserModal extends React.Component {

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(user) {
    this.props.onSubmit(user);
  }

  render() {
    let { isOpen, toggle, className, signupState, dispatchResetSignup } = this.props;
    let password = generate({
      length: 10,
      numbers: true,
      uppercase: true
    });

    return (
      <Modal isOpen={isOpen} toggle={toggle} className={'modal-primary ' + className}>
        <ModalHeader toggle={toggle}> Add User </ModalHeader>
        <ReduxAddUserForm dispatchResetSignup={dispatchResetSignup} signupState={signupState} initialValues={{ password }} onSubmit={this.onSubmit} isOpen={isOpen} toggle={toggle} className={className} />
      </Modal>
    );
  }
}


AddUserModal.propTypes = {
  onSubmit: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/views/Users/AddUserModal.js